/**
 *
 * @param {*} token
 */
function setToken(token) {
    if (typeof token === 'string' && token.length > 0) {
        localStorage.setItem('sb-member-token', token);
    }
}

/**
 *
 */
function getToken() {
    return localStorage.getItem('sb-member-token') || null;
}

/**
 *
 */
function removeToken() {
    localStorage.removeItem('sb-member-token');
    localStorage.removeItem('sb-is-dep');
}

/**
 */
function setIsDependent() {
    localStorage.setItem('sb-is-dep', true);
}

/**
 * @returns {string | null}
 */
function isDependent() {
    return localStorage.getItem('sb-is-dep') || null;
}

/**
 * @param {*} token
 */
function setPasswordWasReset(email) {
    if (typeof email === 'string' && email.length > 0) {
        localStorage.setItem('sb-pw-reset', email);
    }
}

/**
 * @returns {string | null}
 */
function PasswordWasReset() {
    return localStorage.getItem('sb-pw-reset') || null;
}

/**
 *
 */
function removePasswordWasReset() {
    localStorage.removeItem('sb-pw-reset');
}

/**
 * @param data
 */
function saveEnrollmentData(data) {
    localStorage.setItem(`sb-enrol-data-${ data.userDetails.userID }`, JSON.stringify(data));
}

/**
 * @param data
 */
function getEnrollmentData(userID) {
    const data = localStorage.getItem(`sb-enrol-data-${ userID }`);
    return data ? JSON.parse(data) : null;
}

/**
 * @param data
 */
function removeEnrollmentData(userID) {
    localStorage.removeItem(`sb-enrol-data-${ userID }`);
}

/**
 */
function removeWhitelabel() {
    localStorage.removeItem('sb-member-whitelabel');
}

/**
 */
function saveWhitelabel(whitelabel) {
    localStorage.setItem('sb-member-whitelabel', JSON.stringify(whitelabel));
}

/**
 */
function getWhitelabel() {
    const data = localStorage.getItem('sb-member-whitelabel');
    return data ? JSON.parse(data) : null;
}

/**
 */
function setRedirectToken(token) {
    if (typeof token === 'string' && token.length > 0) {
        localStorage.setItem('sb-redirect-token', token);
    }
}

/**
 */
function getRedirectToken() {
    return localStorage.getItem('sb-redirect-token') || null;
}

/**
 */
function removeRedirectToken() {
    localStorage.removeItem('sb-redirect-token');
}

/**
 */
function setUserLanguage (language) {
    localStorage.setItem('sb-user-language', language);
}

/**
 */
function getUserLanguage () {
    return localStorage.getItem('sb-user-language');
}

export {
    setToken,
    getToken,
    removeToken,
    setIsDependent,
    isDependent,
    setPasswordWasReset,
    PasswordWasReset,
    removePasswordWasReset,
    saveEnrollmentData,
    getEnrollmentData,
    removeEnrollmentData,
    removeWhitelabel,
    saveWhitelabel,
    getWhitelabel,
    setRedirectToken,
    getRedirectToken,
    removeRedirectToken,
    setUserLanguage,
    getUserLanguage
};